import { useState } from "react";

import Box from "../../components/Box";
import Modal from "../../components/Modal";
import Helpers from "../../commons/helpers";
import Button from "../../components/Button";
import useStrings from "../../hooks/useStrings";
import Typography from "../../components/Typography";
import ControlLabelCheckBox from "../../components/ControlLabelCheckBox";
import OrganizationService from "../../services/identity/organization.service";
import { useCommonComponentContext } from "../../providers/CommonComponentProvider";



const ModalHandelDeleteOrganization = (props: {
    lable?: string;
    openDelete: boolean;
    hidenCheckBox?: boolean;
    params: {
        id: string;
        status?: number;
        clientId: string;
        organizationId: string;
    };
    onOk: () => void;
    onCancle: () => void;
}) => {
    const strings = useStrings();

    const {
        clientId,
        onError,
        onSuccess,
        onShowLoading,
        onHideLoading,
    } = useCommonComponentContext();

    const [allService, setAllService] = useState<boolean>(true);

    const handleSubmit = async () => {
        try {
            onShowLoading();

            const result = await OrganizationService.delete({
                allService: allService,
                id: props.params.id,
                clientId: clientId,
            });

            if (result.statusCode === 200) {
                onSuccess(strings.format(strings.Organization.DELETE_SUCCESS, props.lable));

                props.onOk && props.onOk();
            }

        } catch (error: any) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        } finally {
            onHideLoading();
        }
    };

    return (
        <Modal
            fullWidth
            maxWidth="sm"
            visible={props.openDelete || false}
            onClose={() => { props.onCancle(); }}
        >
            <Box sx={{
                gap: "24px",
                display: "flex",
                flexDirection: "column",
            }}>
                <Box sx={{
                    marginTop: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <Box sx={{
                        width: "77px",
                        height: "77px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "0.25em solid #facea8",
                        borderRadius: "50%",
                    }}>
                        <Box sx={{
                            color: "#facea8",
                            fontSize: "3.75rem"
                        }}>
                            !
                        </Box>
                    </Box>
                </Box>
                <Box display={"grid"}>
                    <Box>
                        <Typography sx={{
                            padding: 0,
                            overflow: "auto",
                            fontSize: "1rem",
                            textAlign: "center",
                            fontWeight: "normal",
                            lineHeight: "normal",
                        }}>
                            {strings.format(strings.Organization.CONFIRM_REMOVE_SERVICE, props.lable)}
                        </Typography>
                    </Box>
                    {!props.hidenCheckBox &&
                        <Box sx={{
                            gap: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}>
                            <ControlLabelCheckBox
                                isRow
                                value={allService}
                                label={strings.Staff.DELETE_ALL_SERVICE}
                                onChangeValue={(value) => { setAllService(value); }}
                            />
                        </Box>
                    }
                </Box>
                <Box
                    gap={1}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Button color="secondary" onClick={props.onCancle} >{strings.Common.CANCEL}</Button>
                    <Button onClick={handleSubmit} >{strings.Common.ACCEPT}</Button>
                </Box>
            </Box>
        </Modal>
    )
};

export default ModalHandelDeleteOrganization;